import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useEffect, PropsWithChildren } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { useLocalizeDocumentAttributes } from 'hooks';

const dayjsLocales = {
  es: () => import('dayjs/locale/es'),
  ar: () => import('dayjs/locale/ar'),
  de: () => import('dayjs/locale/de'),
  zh: () => import('dayjs/locale/zh'),
  fr: () => import('dayjs/locale/fr'),
  vi: () => import('dayjs/locale/vi'),
  hi: () => import('dayjs/locale/hi'),
  pl: () => import('dayjs/locale/pl'),
  el: () => import('dayjs/locale/el'),
  it: () => import('dayjs/locale/it'),
  en: () => import('dayjs/locale/en'),
  tl: () => import('dayjs/locale/tl-ph'),
  hmn: () => import('lib/dayjs/locale/hmn'),
};

export const LocalizedProvider = ({ children }: PropsWithChildren) => {
  const { i18n } = useTranslation();
  useLocalizeDocumentAttributes();

  useEffect(() => {
    const loadLocale = async () => {
      const currentLocale = i18n.language;
      const localeLoader =
        dayjsLocales[currentLocale as keyof typeof dayjsLocales];

      if (localeLoader) {
        try {
          await localeLoader();
          dayjs.locale(currentLocale);
        } catch (error) {
          console.error(
            `Failed to load dayjs locale for ${currentLocale}:`,
            error
          );
        }
      }
    };

    loadLocale();
  }, [i18n.language]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={i18n.language}
    >
      {children}
    </LocalizationProvider>
  );
};
